const maybeDataTestId = (testId, suffix) => {
  if (testId === undefined) {
    return {};
  }
  const fullTestId = suffix ? `${testId}-${suffix}` : testId;
  return {
    'data-testid': fullTestId
  };
};
export default maybeDataTestId;